const assets = {
    1: {
        "title": "Liszt",
        "sound": "./sounds/liszt.mp3"
    }
};

export default assets;